import { useNavigate } from 'react-router-dom';

import './styles/CreateStickersButton.css';

export default function CreateStickersButton({ to, onClick = null }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <button type="button" className="create-stickers-button" onClick={handleClick}>
      <div className="add-button-bar horizontal" />
      <div className="add-button-bar vertical" />
    </button>
  );
}
